// index.js or main file
import React, {useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import UserRules from './pages/rules/rules';
import ThankYou from './pages/thankyou/thankyou';
import Game from './pages/game/game';
import Leaderboard from './pages/leaderboard/leaderboard';
import Feedback from './pages/feedback/feedback';
import USER from './pages/dddUI/user';
import AddContent from './admin/pages/addcontent/AddContent';
import CustomizeSpotTheme from './admin/pages/customize-spot-theme/CustomizeSpotTheme';
import SpotMapPage from './admin/pages/spot-map/SpotMapPage';
import ThemeUpdate from './admin/pages/theme-update/ThemeUpdate';


function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    if (!location.pathname.startsWith("/admin")) {
      body.classList.add("common-bg");
    } else {
      body.classList.remove("common-bg");
    }
  }, [location]); 
}


function App() {
  usePageBackground();

   return (
    <Provider store={store}>
      <Routes>
        {/* Admin routes (no DDDUI wrapper) */}
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Rules /></Admin>} />
          <Route path="theme-update" element={<Admin><ThemeUpdate /></Admin>} />
          <Route path="addcontent" element={<Admin><AddContent/></Admin>} />
          <Route path="customize-spot" element={<Admin><CustomizeSpotTheme /></Admin>} />
          <Route path="spot-map" element={<Admin><SpotMapPage /></Admin>} />
          <Route path="superadmin" element={<LoginPage/>} />
        </Route>

        {/* Public routes wrapped with DDDUI */}
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/rules" element={<UserRules/>} />
              <Route path="/game" element={<Game/>} />
              <Route path="/leaderboard" element={<Leaderboard/>} />
              <Route path="/feedback" element={<Feedback/>} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/thankyou" element={<ThankYou/>} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
